(() => {
  const initializeHomes = (scope = document) => {
    scope.querySelectorAll('[data-atease-d4-homes]').forEach((root) => {
      if (root.dataset.ateaseD4Ready === 'true') return;
      root.dataset.ateaseD4Ready = 'true';

      const videos = [...root.querySelectorAll('[data-atease-d4-video]')];
      videos.forEach((video) => {
        video.autoplay = false;
        video.muted = true;
        video.preload = 'none';
        video.addEventListener('play', () => {
          videos.forEach((other) => {
            if (other !== video && !other.paused) other.pause();
          });
        });
      });
    });
  };

  const boot = () => initializeHomes(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => initializeHomes(event.target));
})();
